import { Component, signal } from '@angular/core';
import { OccCollection } from 'app/classes/occ-collection';
import { APIService } from 'app/shared/api.service';
import { OccupancyService } from 'app/shared/occupancy.service';
import { WindowService } from 'app/shared/window.service';


@Component({
  selector: 'app-occupancy-admin-collections',
  templateUrl: './occupancy-admin-collections.component.html',
  styleUrls: ['./occupancy-admin-collections.component.css'],
  providers: [],
  standalone: false
})
export class OccupancyAdminCollectionsComponent {

  collections: OccCollection[];
  dows = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
  isAdmin = false;
  isWorking = signal<boolean>(false);
  collection = signal<OccCollection>(null);

  constructor(private occupancyService: OccupancyService, private apiService: APIService, private windowService: WindowService) {
    this.get();
    this.isAdmin = this.apiService.isAdmin();
  }

  get() {
    this.isWorking.set(true);
    this.occupancyService.getCollections().then(collections => {
      this.collections = collections;
      this.isWorking.set(false);
    });
  }

  autorebuild() {
    const startDate = new Date();
    this.apiService.toastSuccess('Building recent missing dates...', '');
    this.occupancyService.autoRebuild().then(response => {
      console.log(response);
      const endDate = new Date();
      const seconds = (endDate.getTime() - startDate.getTime()) / 1000;
      if (seconds >= 29) {
        this.apiService.toastSuccess('Rebuilding may take some time.', '');
      } else {
        this.apiService.toastSuccess('Rebuilding done', '');
      }
    });
  }

  collectionClick(collection: OccCollection) {
    // this.createOrUpdateCollectionOfDays(collection);
    this.collection.set(collection);

  }

  rebuild(collectionId: number, jobId: number) {
    const startDate = new Date();
    this.apiService.toastSuccess('Collection rebuilding...', '');
    this.occupancyService.rebuildCollection(collectionId, jobId).then(response => {
      console.log(response);
      const endDate = new Date();
      const seconds = (endDate.getTime() - startDate.getTime()) / 1000;
      if (seconds >= 29) {
        this.apiService.toastSuccess('Rebuilding may take some time', '');
      } else {
        this.apiService.toastSuccess('Rebuilding done', '');
      }
    });
  }

  createOrUpdateCollectionOfDays(collection?: OccCollection) {
    this.collection.set(new OccCollection());

  }
}
